import axios from 'axios';
import {loadFromLocalStorage} from './reducers/index'

export const requestConfig = () => {
    axios.interceptors.request.use(request => {
        let userData = loadFromLocalStorage();
        if (!request.url.includes("/login")) {
            if (
                userData &&
                userData.currentUser && 
                userData.currentUser.user
              ) {
                request.headers[
                  "Authorization"
                ] = `Bearer ${userData.currentUser.user}`;
              }
            return Promise.resolve(request)
        } else {
          return Promise.resolve(request)
        }
    }, error => {
        console.error('error',error)
        return Promise.reject(error)
    })
}


export const responseConfig = () => {
    axios.interceptors.response.use(response => {
        return response
    }, error => {
        return Promise.reject(error)
    })
}